import Vue from 'vue';
import VueClockPicker from 'vue-clock-picker';

Vue.use(VueClockPicker);
